export default "__VITE_ASSET__CLBbnOi4__"